var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateFailureIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24475_15919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 66C59.6731 66 74 51.6731 74 34C74 16.3269 59.6731 2 42 2C24.3269 2 10 16.3269 10 34C10 51.6731 24.3269 66 42 66Z",
    fill: "#C91D25"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24475_15919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7904 33.5204L54.5249 23.7856C55.1584 23.1524 55.1584 22.1286 54.5249 21.4954C53.8917 20.8622 52.8679 20.8622 52.2347 21.4954L42.4999 31.2302L32.7654 21.4954C32.1319 20.8622 31.1083 20.8622 30.4751 21.4954C29.8416 22.1286 29.8416 23.1524 30.4751 23.7856L40.2096 33.5204L30.4751 43.2552C29.8416 43.8884 29.8416 44.9123 30.4751 45.5455C30.7907 45.8613 31.2056 46.02 31.6202 46.02C32.0349 46.02 32.4495 45.8613 32.7654 45.5455L42.4999 35.8107L52.2347 45.5455C52.5505 45.8613 52.9651 46.02 53.3798 46.02C53.7944 46.02 54.209 45.8613 54.5249 45.5455C55.1584 44.9123 55.1584 43.8884 54.5249 43.2552L44.7904 33.5204Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24475_15919",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.209409 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24475_15919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24475_15919",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24475_15919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(30 21)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateFailureIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/createFailureIcon.d04eac2828e78777f472365ecf422ed5.svg";